export default "__VITE_PUBLIC_ASSET__1cd10d94__"